import { render, staticRenderFns } from "./VideoRecorder.vue?vue&type=template&id=4df2e152&scoped=true&"
import script from "./VideoRecorder.vue?vue&type=script&lang=js&"
export * from "./VideoRecorder.vue?vue&type=script&lang=js&"
import style0 from "./VideoRecorder.vue?vue&type=style&index=0&id=4df2e152&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4df2e152",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
